<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-club" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <v-select name="Department" v-model="club.DepartmentId" item-title="DepartmentName" item-value="DepartmentId" :items="departments" label="Avdelning">

                                </v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="ClubName"
                                              id="ClubName"
                                              type="text"
                                              label="Klubbnamn"
                                              variant="outlined"
                                              v-model="club.ClubName"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="Adress"
                                              id="Adress"
                                              type="text"
                                              label="Adress"
                                              variant="outlined"
                                              v-model="club.Address"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="ZipCode"
                                              id="ZipCode"
                                              type="text"
                                              label="Postnummer"
                                              variant="outlined"
                                              v-model="club.ZipCode"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="City"
                                              id="City"
                                              type="text"
                                              label="Ort"
                                              variant="outlined"
                                              v-model="club.City"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="Telephone"
                                              id="Telephone"
                                              type="text"
                                              label="Telefon"
                                              variant="outlined"
                                              v-model="club.Telephone"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { getCurrentInstance } from 'vue'
    import ValidationService from "../../../Services/ValidationService";
    import AdminService from "../../../Services/AdminService";

    export default {
        emits: ['updated'],
        name: 'update-club',
        props: {

        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async open(club) {
                this.club = club;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            async save() {
                await AdminService.updateClub(this.club)
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");
            },
            reset() {

            },
            async loadDepartments() {
                this.departments = [{ DepartmentName: 'Ingen vald', DepartmentId: null }, ...await AdminService.getDepartments()];
            },
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                thisModal: {},
                club: {},
                departments: [],
            };
        },
        watch: {

        },
        mounted() {
            this.loadDepartments();

            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
